import { TInfrastructureItem } from '../../../../../types/map';

export function getDateText(infrastructureItem: TInfrastructureItem): string | undefined {
  if ('constructionDateText' in infrastructureItem) {
    return infrastructureItem.constructionDateText;
  }

  return undefined;
}
